module.exports = __webpack_public_path__ + "img/icon86.37dd61a6.png";